module.exports = __webpack_public_path__ + "static/media/Tobeaccepted.0816a205.png";